var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_16)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 4.16667C12.5 3.0616 12.939 2.00179 13.7204 1.22039C14.5018 0.438987 15.5616 0 16.6667 0H41.6667C42.7717 0 43.8315 0.438987 44.6129 1.22039C45.3943 2.00179 45.8333 3.0616 45.8333 4.16667V29.1667C45.8333 30.2717 45.3943 31.3315 44.6129 32.1129C43.8315 32.8943 42.7717 33.3333 41.6667 33.3333H39.5833C39.0308 33.3333 38.5009 33.1138 38.1102 32.7231C37.7195 32.3324 37.5 31.8025 37.5 31.25V15.625C37.5 13.6911 36.7318 11.8365 35.3643 10.469C33.9969 9.10156 32.1422 8.33333 30.2083 8.33333H14.5833C14.0308 8.33333 13.5009 8.11384 13.1102 7.72314C12.7195 7.33244 12.5 6.80253 12.5 6.25V4.16667ZM0 16.6667C0 15.5616 0.438987 14.5018 1.22039 13.7204C2.00179 12.939 3.0616 12.5 4.16667 12.5H29.1667C30.2717 12.5 31.3315 12.939 32.1129 13.7204C32.8943 14.5018 33.3333 15.5616 33.3333 16.6667V41.6667C33.3333 42.7717 32.8943 43.8315 32.1129 44.6129C31.3315 45.3943 30.2717 45.8333 29.1667 45.8333H4.16667C3.0616 45.8333 2.00179 45.3943 1.22039 44.6129C0.438987 43.8315 0 42.7717 0 41.6667V16.6667Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyBlack);
export default __webpack_public_path__ + "static/media/copy-black.a4c7e8dff9e3432c9ef63d0d51735a60.svg";
export { ForwardRef as ReactComponent };